var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#DDE0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47176 6.87977C9.47176 8.46377 7.16776 8.28377 7.51576 10.3958L8.77576 10.3838C8.52376 8.87177 10.9478 8.93177 10.9478 6.57977C10.9478 5.42777 10.0238 4.46777 8.42776 4.46777C7.34776 4.46777 6.48376 4.99577 6.05176 5.69177L6.86776 6.61577C7.25176 6.11177 7.68376 5.84777 8.34376 5.84777C8.99176 5.84777 9.47176 6.31577 9.47176 6.87977ZM7.25176 12.0998C7.25176 12.5918 7.61176 13.0598 8.19976 13.0598C8.72776 13.0598 9.08776 12.5918 9.08776 12.0998C9.08776 11.6798 8.72776 11.2118 8.19976 11.2118C7.61176 11.2118 7.25176 11.6798 7.25176 12.0998Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.164fc013.svg";
export { ForwardRef as ReactComponent };